module.exports = __webpack_public_path__ + "img/sakuya izayoi scarlet.d28b61f1.png";